import {TCircleArrowIconProps} from "@/app/[locale]/common/assets/CircleArrowIcon/types";
import s from '../../components/TextIconLink/TextIconLink.module.scss';

export const CircleArrowIcon = ({ color = 'black' }: TCircleArrowIconProps) => {
    return (
        <svg className={`${color === 'black' ? s[`circleArrowIconBlack`] : s[`circleArrowIconWhite`]}`} width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="20" cy="20" r="19.5"/>
            <path
                d="M22.8525 19.7995L17.427 14.3732L17.0741 14.726L22.1446 19.7975L22.4981 20.151L22.1446 20.5046L17.0733 25.5758L17.4269 25.9291L22.8526 20.5054L22.8536 20.5043C22.9 20.4582 22.9368 20.4034 22.9619 20.3431C22.9871 20.2827 23 20.2179 23 20.1525C23 20.0871 22.9871 20.0224 22.9619 19.962C22.9368 19.9016 22.9 19.8468 22.8536 19.8007L22.8525 19.7995Z"/>
        </svg>
    );
};